import { defaultFetch, defaultFetchWithMeta } from './baseApi';

export type StatusOwnerType = {
	userId: number;
	email: string;
	firstName: string;
	lastName: string;
	invoiceCount: number;
};

type MetaType = {
	total: number;
};

export const getOwnershipStatus = (projectId: string, queryParamsString?: string) => {
	return defaultFetchWithMeta<StatusOwnerType[], MetaType>(`/v0/projects/${projectId}/ownershipinvoicesstatus${queryParamsString || ''}`);
};

export const getOwnershipStatusForSampling = (projectId: string, samplingId: number, queryParamsString?: string) => {
	return defaultFetchWithMeta<StatusOwnerType[], MetaType>(
		`/v0/projects/${projectId}/samples/${samplingId}/ownershipstatus${queryParamsString || ''}`,
	);
};

export const assignMassiveOwnership = async (projectId: string, userIds: number[]) => {
	return defaultFetch(`/v0/projects/${projectId}/assigninvoicesownership`, {
		method: 'POST',
		body: JSON.stringify({ userIds }),
	});
};

export const assignMassiveOwnershipForSampling = async (projectId: string, samplingId: number, userIds: number[]) => {
	return defaultFetch(`/v0/projects/${projectId}/samples/${samplingId}/assignownership`, {
		method: 'POST',
		body: JSON.stringify({ userIds }),
	});
};

export const assignOwnershipOnSingleInvoice = async (projectId: string, invoiceId: number, userIds: number[]) => {
	return defaultFetch(`/v0/projects/${projectId}/invoices/${invoiceId}/assignownership`, {
		method: 'POST',
		body: JSON.stringify({ userIds }),
	});
};
export const removeOwnershipOnSingleInvoice = async (
	projectId: string,
	invoiceId: number,
	//  userIds: number[]
) => {
	return defaultFetch(`/v0/projects/${projectId}/invoices/${invoiceId}/removeownerships`, {
		method: 'POST',
		// body: JSON.stringify({ userIds }),
	});
};
